<script>
export let code;
export let msg_show;
export let msg_text;
export let msg_type; // error or success


import { Navigate } from 'svelte-router-spa';
import CopyToClipboard from 'svelte-copy-to-clipboard';


const handleSuccessfullyCopied = (e) => {
	// alert(`successfully copied to clipboard! ${e}`);
	msg_show = true;
	msg_text = 'Code copied!';
	msg_type = 'success';
}
const handleFailedCopy = () => {
	// alert('failed to copy code');
	msg_show = true;
	msg_text = 'Failed to copy code.';
	msg_type = 'error';
}

</script>



<style>

#see-new-code {

}

p {
	color: var(--text-light);
	margin-bottom: 1.5rem !important;
	font-size: 1.075rem !important;
}

:global(#see-new-code p a) {
	color: var(--text-light);
	text-decoration: underline;
}

:global(#see-new-code p a):hover {
	color: var(--text-light) !important;
	text-decoration: underline !important;
}

</style>



<div class="card form-card" id="see-new-code">

	<div class="card-content">

		<p>
			Click the button below to copy your new code. Afterwards go back to <Navigate to="/login">login</Navigate>!
		</p>

		<div class="field is-grouped">

			<div class="control">

				<CopyToClipboard text={code} on:copy={handleSuccessfullyCopied} on:fail={handleFailedCopy} let:copy>
	      				<button class="button is-blue" on:click={copy}>{code}</button>
				</CopyToClipboard>

			</div>

		</div>

	</div>

</div>


